import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useLogout from "components/common/useLogout";
import GenericModal from "components/common/GenericModal";
import { ICONS } from "components/common/constants/swal.constants";
import "./OfficeKioskLayout.css";

interface OfficeKioskLayoutProps {
  currentUser: any; // or your real user type
  children?: React.ReactNode;
}

const OfficeKioskLayout: React.FC<OfficeKioskLayoutProps> = ({
  currentUser,
  children,
}) => {
  const history = useHistory();

  const [genericModalData, setGenericModalData] = useState<{
    show: boolean;
    title?: string;
    subtext?: string;
    icon?: any;
  }>({ show: false });

  const showLogoutSuccess = () => {
    setGenericModalData({
      show: true,
      title: "Goodbye",
      subtext: "See you next time!",
      icon: ICONS.checkMark,
    });
  };

  const showLogoutError = () => {
    setGenericModalData({
      show: true,
      title: "Oops!",
      subtext: "Some error occurred",
      icon: ICONS.error,
    });
  };

  const hideModal = () => {
    setGenericModalData((prev) => ({ ...prev, show: false }));
  };

  const logOut = useLogout(
    "/login",
    showLogoutSuccess,
    showLogoutError,
    hideModal
  );

  useEffect(() => {
    if (!currentUser || currentUser.roleId !== 9) {
      history.replace("/login");
    }
  }, [currentUser, history]);

  if (!currentUser || currentUser.roleId !== 9) {
    return null;
  }

  return (
    <div className="ok-layout-root">
      {genericModalData.show && (
        <GenericModal
          show={genericModalData.show}
          onHide={hideModal}
          title={genericModalData.title || ""}
          subtext={genericModalData.subtext || ""}
          icon={genericModalData.icon}
          hideBtn
        />
      )}

      <div className="ok-layout-main">{children}</div>

      <footer className="ok-layout-footer">
        <span className="ok-footer-text">MyRep Office Kiosk</span>
        <button
          className="ok-footer-logout-btn"
          onClick={() => logOut()}
          data-cy="kiosk-logout-btn"
        >
          Log out
        </button>
      </footer>
    </div>
  );
};

export default OfficeKioskLayout;
